import { Component, Injector, Input } from '@angular/core';
import { BaseView } from '../../base-view';

@Component({
  selector: 'app-page-layout-new',
  templateUrl: './page-layout-new.component.html',
  styleUrls: ['./page-layout-new.component.scss']
})
export class PageLayoutNewComponent extends BaseView {

  @Input() content;

  constructor(protected _injector: Injector){
    super(_injector)
  }
}
